import React from "react";

/**
 * LoadingState Component
 * 
 * Displays a loading spinner while images are being fetched
 * 
 * @returns {JSX.Element} Loading state UI
 */
export const LoadingState = () => {
  return (
    <div className="uploaded-images-container">
      <div className="loading-spinner">
        <div className="spinner" />
        <p>Loading...</p>
      </div>
    </div>
  );
};

/**
 * EmptyState Component
 * 
 * Displays a message when no images are available for the event
 * 
 * @returns {JSX.Element} Empty state UI
 */
export const EmptyState = () => {
  return (
    <div className="empty-state">
      <div className="empty-icon">📷</div>
      <h2>No images yet</h2>
      <p>You haven't uploaded any images for this event.</p>
      <button
        className="back-to-camera-btn"
        onClick={() => window.history.back()}
      >
        Back to Camera
      </button>
    </div>
  );
};

/**
 * FullPageLoader Component
 * 
 * Displays a full-page loading overlay during delete operations
 * 
 * @returns {JSX.Element} Full-page loader UI
 */
export const FullPageLoader = ({ message = "Deleting photo…" }) => {
  return (
    <div className="full-page-loader" role="status">
      <div className="loader-spinner"></div>
      <span>{message}</span>
    </div>
  );
};

/**
 * ErrorState Component
 * 
 * Displays an error message when images fail to load
 * 
 * @param {Object} props - Component props
 * @param {Function} props.onRetry - Function to handle retry action
 * 
 * @returns {JSX.Element} Error state UI
 */
export const ErrorState = ({ onRetry }) => {
  return (
    <div className="uploaded-images-container">
      <div className="error-container">
        <div className="error-icon">⚠️</div>
        <div className="error-message">Failed to load images</div>
        <button className="retry-button" onClick={onRetry}>
          Retry
        </button>
      </div>
    </div>
  );
};
